require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/fn/regexp/escape.js
// module id = 912
// module chunks = 27